import { render, staticRenderFns } from "./guideDetails.vue?vue&type=template&id=dc8acb64&scoped=true&"
import script from "./guideDetails.vue?vue&type=script&lang=js&"
export * from "./guideDetails.vue?vue&type=script&lang=js&"
import style0 from "./guideDetails.vue?vue&type=style&index=0&id=dc8acb64&scoped=true&lang=css&"
import style1 from "./guideDetails.vue?vue&type=style&index=1&id=dc8acb64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8acb64",
  null
  
)

export default component.exports